import {useAppDispatch, useAppSelector} from "../redux/stateHooks";
import {accordionHeaderOnClick} from "../redux/slices/accordion";
import {AccordionItemType} from "../definitions/enums";

export const useAccordionVariables = () => {
    const dispatch = useAppDispatch();
    const variables = useAppSelector(state => state.accordion.value)

    return {
        variables,
        onClick: (type: AccordionItemType) => dispatch(accordionHeaderOnClick(type))
    };
}